"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgPaperclip = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M32.733 23.343a1 1 0 011.414 1.414l-9.19 9.19a7.003 7.003 0 01-9.904-9.904l9.19-9.19a5.002 5.002 0 117.074 7.074l-9.2 9.19a3.001 3.001 0 11-4.244-4.245l8.49-8.48a1 1 0 011.414 1.416l-8.49 8.48a1.001 1.001 0 101.416 1.415l9.2-9.19a3.002 3.002 0 00-4.246-4.246l-9.19 9.19a5.003 5.003 0 107.076 7.076l9.19-9.19z",
    id: "paperclip_svg__a"
  }));
};

var _default = SvgPaperclip;
exports.default = _default;